import { useEffect } from 'react';

interface Shortcut {
    modifiers?: {
        altKey?: boolean;
        ctrlKey?: boolean;
    };
    onEvent: () => void;
}

export type Shortcuts = Record<string, Shortcut>;

export const useShortcuts = (shortcuts: Shortcuts) => {
    useEffect(() => {
        const handleKeyup = (event: KeyboardEvent) => {
            if (
                shortcuts[event.code] &&
                event.altKey === !!shortcuts[event.code].modifiers?.altKey &&
                event.ctrlKey === !!shortcuts[event.code].modifiers?.ctrlKey
            ) {
                event.preventDefault();
                event.stopPropagation();
                shortcuts[event.code].onEvent();
            }
        };

        window.addEventListener('keyup', handleKeyup);
        return () => {
            window.removeEventListener('keyup', handleKeyup);
        };
    }, [shortcuts]);
};
